const myProduct = 
[
	{
		"id" : 1,
		"orderSeq" : "1",
		"name" : "Cooling Fan Cover For MANY / VJR",
		"name_ch" : "MANY / VJR透明燻黑風扇蓋",
		"classfied" : "New",
		"sale_price" : [
			{
				"currencyTW" : "NTD$",
				"priceTW" : "500"
			}
		],
		"price" : [
			{
				"item" : "風扇蓋",
				"wholesale_price" : [
					{
						"qty" : "10",
						"unitPrice" : "400",
						"desc" : "(10搭3)"
					},
					{
						"qty" : "50",
						"unitPrice" : "250"
					},
					{
						"qty" : "100",
						"unitPrice" : "200"
					},
					{
						"qty" : "500",
						"unitPrice" : "100"
					}
				]
			}
		],
		"imageDirectory" : "styles/image/product/cooling_fan_many_vjr/",
		"productRelativeImageUrl" : [
			{
				"imageNo" : "1",
				"imageUrl" : "p1.jpg",
				"imageHint" : "圖1"
			},
			{
				"imageNo" : "2",
				"imageUrl" : "p2.jpg",
				"imageHint" : "圖2"
			}
		],
		"displayModelInDetail" : "false",
		"suitable_model" : [
			{
				"display_type" : "ALL",
				"model" : "VJR100/110/125 MANY100/110/125"
			}
		],
		"description" : [
			{
				"desc_index" : "1",
				"desc_content" : "・彩色飾蓋為贈品有紅/藍/黃/綠/粉紅五種顏色"
			},
			{
				"desc_index" : "2",
				"desc_content" : "・改上繞/側繞/下繞排氣管均可直上免修改不卡管"
			}
		]
	},
	{
		"id" : 2,
		"orderSeq" : "2",
		"name" : "Cooling Fan Cover With Changeable Rainbow Chrome Bedge For MANY / VJR",
		"name_ch" : "MANY / VJR透明燻黑風扇蓋+彩鈦電鍍飾蓋",
		"classfied" : "New",
		"sale_price" : [
			{
				"currencyTW" : "NTD$",
				"priceTW" : "650"
			}
		],
		"price" : [
			{
				"item" : "風扇蓋",
				"wholesale_price" : [
					{
						"qty" : "10",
						"unitPrice" : "400",
						"desc" : "(10搭3)"
					},
					{
						"qty" : "50",
						"unitPrice" : "250"
					},
					{
						"qty" : "100",
						"unitPrice" : "200"
					},
					{
						"qty" : "500",
						"unitPrice" : "100"
					}
				]
			},
			{
				"item" : "彩鈦飾蓋",
				"wholesale_price" : [
					{
						"qty" : "10",
						"unitPrice" : "120",
						"desc" : "(10搭3)"
					},
					{
						"qty" : "50",
						"unitPrice" : "90",
						"desc" : "(10搭2)"
					},
					{
						"qty" : "100",
						"unitPrice" : "60"
					},
					{
						"qty" : "500",
						"unitPrice" : "請詢價"
					}
				]
			}
		],
		"imageDirectory" : "styles/image/product/cooling_fan_changeable_bedge_many_vjr/",
		"productRelativeImageUrl" : [
			{
				"imageNo" : "1",
				"imageUrl" : "p1.jpg",
				"imageHint" : "圖1-E字型"
			},
			{
				"imageNo" : "2",
				"imageUrl" : "p2.jpg",
				"imageHint" : "圖2-指針式"
			},
			{
				"imageNo" : "3",
				"imageUrl" : "p3.jpg",
				"imageHint" : "圖3-小旋風"
			}
		],
		"displayModelInDetail" : "false",
		"suitable_model" : [
			{
				"display_type" : "ALL",
				"model" : "VJR100/110/125 MANY100/110/125"
			}
		],
		"description" : [
			{
				"desc_index" : "1",
				"desc_content" : "・彩鈦電鍍飾蓋有3款可選擇"
			},
			{
				"desc_index" : "2",
				"desc_content" : "・圖3小旋風飾蓋為改管專用,不論是上繞/側繞/下繞管均可直上不卡管"
			}
		]
	},
	{
		"id" : 3,
		"orderSeq" : "3",
		"name" : "Cooling Fan Cover With Changeable Rainbow Chrome Bedge And COB For MANY / VJR",
		"name_ch" : "MANY / VJR透明燻黑風扇蓋+彩鈦電鍍飾蓋+COB光圈",
		"classfied" : "New",
		"sale_price" : [
			{
				"currencyTW" : "NTD$",
				"priceTW" : "1200"
			}
		],
		"price" : [
			{
				"item" : "風扇蓋",
				"wholesale_price" : [
					{
						"qty" : "10",
						"unitPrice" : "400",
						"desc" : "(10搭3)"
					},
					{
						"qty" : "50",
						"unitPrice" : "250"
					},
					{
						"qty" : "100",
						"unitPrice" : "200"
					},
					{
						"qty" : "500",
						"unitPrice" : "100"
					}
				]
			},
			{
				"item" : "彩鈦飾蓋",
				"wholesale_price" : [
					{
						"qty" : "10",
						"unitPrice" : "120",
						"desc" : "(10搭3)"
					},
					{
						"qty" : "50",
						"unitPrice" : "90",
						"desc" : "(10搭2)"
					},
					{
						"qty" : "100",
						"unitPrice" : "60"
					},
					{
						"qty" : "500",
						"unitPrice" : "請詢價"
					}
				]
			},
			{
				"item" : "COB光圈",
				"wholesale_price" : [
					{
						"qty" : "10",
						"unitPrice" : "請詢價"
					},
					{
						"qty" : "50",
						"unitPrice" : "請詢價"
					},
					{
						"qty" : "100",
						"unitPrice" : "請詢價"
					},
					{
						"qty" : "500",
						"unitPrice" : "請詢價"
					}
				]
			}			
		],
		"imageDirectory" : "styles/image/product/cooling_fan_with_bedge_cob_for_many_vjr/",
		"productRelativeImageUrl" : [
			{
				"imageNo" : "1",
				"imageUrl" : "p1.jpg",
				"imageHint" : "圖1"
			}
		],
		"displayModelInDetail" : "false",
		"suitable_model" : [
			{
				"display_type" : "ALL",
				"model" : "VJR100/110/125 MANY100/110/125"
			}
		],
		"description" : [
			{
				"desc_index" : "1",
				"desc_content" : "・COB光圈有白/藍/紅/綠/紫五種光色;彩鈦飾蓋有E字型/指針式兩款"
			}
		]
	},
	{
		"id" : 4,
		"orderSeq" : "4",
		"name" : "Carbon Cooling Fan",
		"name_ch" : "碳纖複合輕量化高速風扇",
		"classfied" : "New",
		"sale_price" : [
			{
				"currencyTW" : "NTD$",
				"priceTW" : "450"
			}
		],
		"price" : [
			{
				"item" : "風扇蓋",
				"wholesale_price" : [
					{
						"qty" : "10",
						"unitPrice" : "320",
						"desc" : "(10搭3)"
					},
					{
						"qty" : "50",
						"unitPrice" : "200"
					},
					{
						"qty" : "100",
						"unitPrice" : "150"
					},
					{
						"qty" : "500",
						"unitPrice" : "100"
					}
				]
			}
		],
		"imageDirectory" : "styles/image/product/carbon_cooling_fan/",
		"productRelativeImageUrl" : [
			{
				"imageNo" : "1",
				"imageUrl" : "p1.jpg",
				"imageHint" : "圖1"
			},
			{
				"imageNo" : "2",
				"imageUrl" : "p2.jpg",
				"imageHint" : "圖2"
			},
			{
				"imageNo" : "3",
				"imageUrl" : "p3.jpg",
				"imageHint" : "圖3"
			},
			{
				"imageNo" : "4",
				"imageUrl" : "p4.jpg",
				"imageHint" : "圖4"
			},
			{
				"imageNo" : "5",
				"imageUrl" : "p5.jpg",
				"imageHint" : "圖5"
			}			
		],
		"displayModelInDetail" : "true",
		"suitable_model" : [
			{
				"display_type" : "BY_TYPE",
				"motor_system" : "Y001C-YAMAHA車系",
				"model" : "BWS 125/BWSX/BWSR/勁戰全車系(一代~四代)/GTR aero/ RAY"
			},		
			{
				"display_type" : "BY_TYPE_VENDOR",
				"motor_system" : "K03C-GY6系統",
				"model" : [
					{
						"vendor" : "KYMCO",
						"model" : "雷霆/雷霆S/G3/G4/G5/G6/超5/奔騰/奔馳/豪邁/GP/VP/金牌"
					},
					{
						"vendor" : "SYM",
						"model" : "FIGHTER(一代~五代)/迪爵/GT"
					},
					{
						"vendor" : "宏佳騰",
						"model" : "OZ"
					},
					{
						"vendor" : "哈特佛",
						"model" : "大黃蜂"
					}
				]
			},
			{
				"display_type" : "BY_TYPE_VENDOR",
				"motor_system" : "K05C- DIO迪奧系列",
				"model" : [
					{
						"vendor" : "SYM",
						"model" : "MANY100/110/125 VJR100/110/125 RX110 IRX115"
					},
					{
						"vendor" : "PGO",
						"model" : "Jbubu"
					}
				]
			},
			{
				"display_type" : "BY_TYPE",
				"motor_system" : "M07C-SYM車系",
				"model" : "JET POWER (EVO)/JETS/GR/Z1/GT125 EVO/6代FIGHTER"
			}
		],
		"description" : [
			{
				"desc_index" : "1",
				"desc_content" : "・不爆裂-使用特殊複合材質(非一般的PP材質), 增強風扇的韌性及強度,延長風扇的使用壽命!!"
			},
			{
				"desc_index" : "2",
				"desc_content" : "・高出風量-加高加大葉片結構可提高出風量,快速中和引擎所產生的熱氣,散熱效果快又好!!"
			},
			{
				"desc_index" : "3",
				"desc_content" : "・輕量化-有效提升油門的靈敏度,讓你的愛車加速更輕更快!!"
			}
		]
	},
	{
		"id" : 5,
		"name" : "TMAX 530 Transmission Parts",
		"name_ch" : "TMAX 530 鏈條傳動套件",
		"classfied" : "Motorcycle",
		"sale_price" : [
			{
				"currencyTW" : "NTD$",
				"priceTW" : "11,000",
				"item" : "・前齒18T+後齒(37T/38T/40T擇一)"
			},
			{
				"currencyTW" : "NTD$",
				"priceTW" : "12,000",
				"item" : "・前齒18T+後齒(41T/43T擇一)"
			}
		],
		"price" : [
			{
				"item" : "前齒18T+後齒(37T/38T/40T擇一)",
				"wholesale_price" : [
					{
						"qty" : "10",
						"unitPrice" : "11,000"
					},
					{
						"qty" : "50",
						"unitPrice" : "11,000"
					},
					{
						"qty" : "100",
						"unitPrice" : "11,000"
					},
					{
						"qty" : "500",
						"unitPrice" : "11,000"
					}
				]
			},
			{
				"item" : "前齒18T+後齒(41T/43T擇一)",
				"wholesale_price" : [
					{
						"qty" : "10",
						"unitPrice" : "12,000"
					},
					{
						"qty" : "50",
						"unitPrice" : "12,000"
					},
					{
						"qty" : "100",
						"unitPrice" : "12,000"
					},
					{
						"qty" : "500",
						"unitPrice" : "12,000"
					}
				]
			}		
		],
		"orderSeq" : "5",
		"imageDirectory" : "styles/image/product/tmax_530_transmission_chain/",
		"productRelativeImageUrl" : [
			{
				"imageNo" : "1",
				"imageUrl" : "p1.jpg",
				"imageHint" : "圖1"
			},
			{
				"imageNo" : "2",
				"imageUrl" : "p2.jpg",
				"imageHint" : "圖2"				
			}
		],
		"displayModelInDetail" : "false",
		"suitable_model" : [
			{
				"display_type" : "ALL",
				"model" : "YAMAHA TMAX 530"
			}
		],
		"description" : [
			{
				"desc_index" : "1",
				"desc_content" : "・前齒輪為18T,鋼造材質一體成型,非拼裝套件!!"
			},
			{
				"desc_index" : "2",
				"desc_content" : "・後齒有37T/38T/40T/41T/43T,不同齒比會產生不同的效果!!"
			},
			{
				"desc_index" : "3",
				"desc_content" : "・此商品組合不含鍊條,鏈條須搭配525鏈條!!"
			}
		]
	},
	{
		"id" : 6,
		"name" : "12\"/14\"/17\"/18\" Rear Fender",
		"name_ch" : "12吋/14吋/17吋/18吋輪框後擋泥板",
		"classfied" : "LightWeightBike",
		"sale_price" : [
			{
				"currencyTW" : "NTD$",
				"priceTW" : "550"
			}
		],
		"price" : [
			{
				"item" : "擋泥板",
				"wholesale_price" : [
					{
						"qty" : "10",
						"unitPrice" : "450",
						"desc" : "(10搭3)"
					},
					{
						"qty" : "50",
						"unitPrice" : "275"
					},
					{
						"qty" : "100",
						"unitPrice" : "220"
					},
					{
						"qty" : "500",
						"unitPrice" : "140"
					}
				]
			}	
		],
		"orderSeq" : "6",
		"imageDirectory" : "styles/image/product/rear_fender_for_12_14_17_18/",
		"productRelativeImageUrl" : [
			{
				"imageNo" : "1",
				"imageUrl" : "p1.jpg",
				"imageHint" : "圖1"
			},
			{
				"imageNo" : "2",
				"imageUrl" : "p2.jpg",
				"imageHint" : "圖2"				
			},
			{
				"imageNo" : "3",
				"imageUrl" : "p3.jpg",
				"imageHint" : "圖3"				
			},
			{
				"imageNo" : "4",
				"imageUrl" : "p4.jpg",
				"imageHint" : "圖4"				
			},
			{
				"imageNo" : "5",
				"imageUrl" : "p5.jpg",
				"imageHint" : "圖5"				
			},
			{
				"imageNo" : "6",
				"imageUrl" : "p6.jpg",
				"imageHint" : "圖6"				
			},
			{
				"imageNo" : "7",
				"imageUrl" : "p7.jpg",
				"imageHint" : "圖7"				
			}
		],
		"displayModelInDetail" : "true",
		"suitable_model" : [
			{
				"display_type" : "BY_TYPE",
				"motor_system" : "RFD12\"",
				"model" : "小雲豹/ AIR …12吋後輪框輕擋車通用"
			},
			{
				"display_type" : "BY_TYPE",
				"motor_system" : "RFD14\"",
				"model" : "MY125/MY150/HONDA MSX/CPI MX150/Kawasaki Z125 …12-14吋後輪框輕擋車通用"
			},
			{
				"display_type" : "BY_TYPE",
				"motor_system" : "RFD17\"",
				"model" : "雲豹 150/雲豹200/MY DREAM125/野狼系列/T1/T2/大野狼SB300/酷龍/KTR …17-18吋後輪框輕擋車通用"
			}
		],
		"description" : [
			{
				"desc_index" : "1",
				"desc_content" : "・擋泥板支架為鋁合金支架,不易斷裂"
			},
			{
				"desc_index" : "2",
				"desc_content" : "・檔泥板本體有黑/白/紅/藍/綠/黃/粉紅等七種顏色"
			}
		]
	},
	{
		"id" : 7,
		"name" : "BWS Carbon Headlight Cover",
		"name_ch" : "大B碳纖維美規小盾牌",
		"classfied" : "Others",
		"sale_price" : [
			{
				"currencyTW" : "NTD$",
				"priceTW" : "1500",
				"item" : "小盾牌"
			},
			{
				"currencyTW" : "NTD$",
				"priceTW" : "1750",
				"item" : "小盾牌+彩殼小燈"
			}
		],
		"price" : [
			{
				"item" : "小盾牌",
				"wholesale_price" : [
					{
						"qty" : "10",
						"unitPrice" : "1500"
					},
					{
						"qty" : "50",
						"unitPrice" : "1500"
					},
					{
						"qty" : "100",
						"unitPrice" : "1500"
					},
					{
						"qty" : "500",
						"unitPrice" : "1500"
					}
				]
			},
			{
				"item" : "小盾牌+彩殼小燈",
				"wholesale_price" : [
					{
						"qty" : "10",
						"unitPrice" : "1750"
					},
					{
						"qty" : "50",
						"unitPrice" : "1750"
					},
					{
						"qty" : "100",
						"unitPrice" : "1750"
					},
					{
						"qty" : "500",
						"unitPrice" : "1750"
					}
				]
			}		
		],
		"orderSeq" : "7",
		"imageDirectory" : "styles/image/product/bws_carbon_headlight_cover/",
		"productRelativeImageUrl" : [
			{
				"imageNo" : "1",
				"imageUrl" : "p1.jpg",
				"imageHint" : "圖1"
			},
			{
				"imageNo" : "2",
				"imageUrl" : "p2.jpg",
				"imageHint" : "圖2"				
			},
			{
				"imageNo" : "3",
				"imageUrl" : "p3.jpg",
				"imageHint" : "圖3"				
			}
		],
		"displayModelInDetail" : "true",
		"suitable_model" : [
			{
				"display_type" : "BY_TYPE",
				"motor_system" : "小盾牌",
				"model" : "大B改美規雙大燈"
			},
			{
				"display_type" : "BY_TYPE",
				"motor_system" : "小盾牌+彩殼小燈",
				"model" : "大B/BWS125/BWSX 原廠直上"
			}
		],
		"description" : [
			{
				"desc_index" : "1",
				"desc_content" : "・小燈內反射面有黑色/電鍍銀兩款(圖3)"
			},
			{
				"desc_index" : "2",
				"desc_content" : "・小燈殼有全透明/透明黃/透明綠/透明藍/透明紅五種顏色(圖3)"
			}
		]
	},
	{
		"id" : 8,
		"name" : "BWS Carbon Triangle Transmission Cover",
		"name_ch" : "大B碳纖維三角傳動蓋",
		"classfied" : "Others",
		"sale_price" : [
			{
				"currencyTW" : "NTD$",
				"priceTW" : "1680"
			}
		],
		"price" : [
			{
				"item" : "傳動蓋",
				"wholesale_price" : [
					{
						"qty" : "10",
						"unitPrice" : "1680"
					},
					{
						"qty" : "50",
						"unitPrice" : "1680"
					},
					{
						"qty" : "100",
						"unitPrice" : "1680"
					},
					{
						"qty" : "500",
						"unitPrice" : "1680"
					}
				]
			}		
		],
		"orderSeq" : "8",
		"imageDirectory" : "styles/image/product/bws_carbon_triangle_transmission_cover/",
		"productRelativeImageUrl" : [
			{
				"imageNo" : "1",
				"imageUrl" : "p1.jpg",
				"imageHint" : "圖1"
			}
		],
		"displayModelInDetail" : "false",
		"suitable_model" : [
			{
				"display_type" : "ALL",
				"model" : "BWS125/BWSX/BWSR/勁戰(一代~四代)"
			}
		],
		"description" : [
		]
	},
	{
		"id" : 9,
		"name" : "Carbon Rear Fender",
		"name_ch" : "碳纖維後擋泥板",
		"classfied" : "Others",
		"sale_price" : [
			{
				"currencyTW" : "NTD$",
				"priceTW" : "1580",
				"item" : "後雙避震車種專用"
			},
			{
				"currencyTW" : "NTD$",
				"priceTW" : "1680",
				"item" : "輕擋車專用"
			}			
		],
		"price" : [
			{
				"item" : "輕擋車專用",
				"wholesale_price" : [
					{
						"qty" : "10",
						"unitPrice" : "1680"
					},
					{
						"qty" : "50",
						"unitPrice" : "1680"
					},
					{
						"qty" : "100",
						"unitPrice" : "1680"
					},
					{
						"qty" : "500",
						"unitPrice" : "1680"
					}
				]
			},
			{	
				"item" : "後雙避震車種專用",
				"wholesale_price" : [
					{
						"qty" : "10",
						"unitPrice" : "1580"
					},
					{
						"qty" : "50",
						"unitPrice" : "1580"
					},
					{
						"qty" : "100",
						"unitPrice" : "1580"
					},
					{
						"qty" : "500",
						"unitPrice" : "1580"
					}
				]
			}						
		],
		"orderSeq" : "9",
		"imageDirectory" : "styles/image/product/carbon_rear_fender/",
		"productRelativeImageUrl" : [
			{
				"imageNo" : "1",
				"imageUrl" : "p1.jpg",
				"imageHint" : "圖1"
			}
		],
		"displayModelInDetail" : "true",
		"suitable_model" : [
			{
				"display_type" : "BY_TYPE",
				"motor_system" : "後雙避震款",
				"model" : "後雙避震之速可達100cc/110cc/125cc/150cc/180cc/220cc均可使用"
			},
			{
				"display_type" : "BY_TYPE_VENDOR",
				"motor_system" : "12”/14”/17”/18”輕擋車適用",
				"model" : [
					{
						"vendor" : "RFD12”",
						"model" : "小雲豹/ AIR …12吋後輪框輕擋車通用"
					},
					{
						"vendor" : "RFD14”",
						"model" : "MY125/MY150/HONDA MSX/CPI MX150/Kawasaki Z125 …12-14吋後輪框輕擋車通用"
					},
					{
						"vendor" : "RFD17”",
						"model" : "雲豹 150/雲豹200/MY DREAM125/野狼系列/T1/T2/大野狼SB300/酷龍/KTR …17-18吋後輪框輕擋車通用"
					}
				]
			}			
		],
		"description" : [
			{
				"desc_index" : "1",
				"desc_content" : "・擋泥板支架材質為鋁合金,不易斷裂"
			}
		]
	},
	{
		"id" : 10,
		"name" : "Majesty S/Smax/1DK/Force Transmission Filter Assembly (BLACK)",
		"name_ch" : "SMAX / FORCE 強制進氣傳動濾心總成(不透明)",
		"classfied" : "Scooter",
		"sale_price" : [
			{
				"currencyTW" : "NTD$",
				"priceTW" : "600"
			}
		],
		"price" : [
			{
				"item" : "傳動濾心總成",
				"wholesale_price" : [
					{
						"qty" : "10",
						"unitPrice" : "430",
						"desc" : "(10搭2)"
					},
					{
						"qty" : "50",
						"unitPrice" : "300"
					},
					{
						"qty" : "100",
						"unitPrice" : "240"
					},
					{
						"qty" : "500",
						"unitPrice" : "150"
					}
				]
			}
		],
		"orderSeq" : "10",
		"imageDirectory" : "styles/image/product/force_transmission_filter_assembly_black/",
		"productRelativeImageUrl" : [
			{
				"imageNo" : "1",
				"imageUrl" : "p1.jpg",
				"imageHint" : "圖1"
			},
			{
				"imageNo" : "2",
				"imageUrl" : "p2.jpg",
				"imageHint" : "圖2"
			}
		],
		"displayModelInDetail" : "false",
		"suitable_model" : [
			{
				"display_type" : "ALL",
				"model" : "Majesty S/Smax/1DK/Force"
			}
		],
		"description" : [
		]
	},
	{
		"id" : 11,
		"name" : "Majesty S/Smax/1DK/Force Transmission Filter Assembly (Transparent)",
		"name_ch" : "SMAX / FORCE 強制進氣傳動濾心總成(透明燻黑)",
		"classfied" : "Scooter",
		"sale_price" : [
			{
				"currencyTW" : "NTD$",
				"priceTW" : "700"
			}
		],
		"price" : [
			{
				"item" : "傳動濾心總成",
				"wholesale_price" : [
					{
						"qty" : "10",
						"unitPrice" : "500",
						"desc" : "(10搭2)"
					},
					{
						"qty" : "50",
						"unitPrice" : "350"
					},
					{
						"qty" : "100",
						"unitPrice" : "280"
					},
					{
						"qty" : "500",
						"unitPrice" : "180"
					}
				]
			}
		],
		"orderSeq" : "11",
		"imageDirectory" : "styles/image/product/force_transmission_filter_assembly_transparent/",
		"productRelativeImageUrl" : [
			{
				"imageNo" : "1",
				"imageUrl" : "p1.jpg",
				"imageHint" : "圖1"
			},
			{
				"imageNo" : "2",
				"imageUrl" : "p2.jpg",
				"imageHint" : "圖2"
			},
			{
				"imageNo" : "3",
				"imageUrl" : "p3.jpg",
				"imageHint" : "圖3"
			}
		],
		"displayModelInDetail" : "false",
		"suitable_model" : [
			{
				"display_type" : "ALL",
				"model" : "Majesty S/Smax/1DK/Force"
			}
		],
		"description" : [
		]
	},
	{
		"id" : 12,
		"name" : "Headlight Cover with Pilot Light for BWS",
		"name_ch" : "大B 小盾牌+彩殼小燈",
		"classfied" : "Scooter",
		"sale_price" : [
			{
				"currencyTW" : "NTD$",
				"priceTW" : "500"
			}
		],
		"price" : [
			{
				"item" : "盾牌+小燈",
				"wholesale_price" : [
					{
						"qty" : "10",
						"unitPrice" : "400",
						"desc" : "(10搭3)"
					},
					{
						"qty" : "50",
						"unitPrice" : "250"
					},
					{
						"qty" : "100",
						"unitPrice" : "200"
					},
					{
						"qty" : "500",
						"unitPrice" : "120"
					}
				]
			}
		],
		"orderSeq" : "12",
		"imageDirectory" : "styles/image/product/headlight_cover_pilot_light_bws/",
		"productRelativeImageUrl" : [
			{
				"imageNo" : "1",
				"imageUrl" : "p1.jpg",
				"imageHint" : "圖1"
			},
			{
				"imageNo" : "2",
				"imageUrl" : "p2.jpg",
				"imageHint" : "圖2"
			},
			{
				"imageNo" : "3",
				"imageUrl" : "p3.jpg",
				"imageHint" : "圖3"
			}
		],
		"displayModelInDetail" : "false",
		"suitable_model" : [
			{
				"display_type" : "ALL",
				"model" : "BWS125/BWSX"
			}
		],
		"description" : [
			{
				"desc_index" : "1",
				"desc_content" : "・大B原廠車可直上免修改,安裝簡單"
			},
			{
				"desc_index" : "2",
				"desc_content" : "・小盾牌有不透明經典黑/透明燻黑兩款,透明燻黑內可加裝燈飾"
			},
			{
				"desc_index" : "3",
				"desc_content" : "・小燈內反射面有黑色/電鍍銀兩款"
			},
			{
				"desc_index" : "4",
				"desc_content" : "・小燈殼有全透明/透明黃/透明綠/透明藍/透明紅五種顏色"
			}
		]
	},
	{
		"id" : 13,
		"name" : "Headlight Cover with Chrome Pilot Light for BWS",
		"name_ch" : "大B 小盾牌+彩鈦電鍍小燈",
		"classfied" : "Scooter",
		"sale_price" : [
			{
				"currencyTW" : "NTD$",
				"priceTW" : "600"
			}
		],
		"price" : [
			{
				"item" : "盾牌+小燈",
				"wholesale_price" : [
					{
						"qty" : "10",
						"unitPrice" : "460",
						"desc" : "(10搭3)"
					},
					{
						"qty" : "50",
						"unitPrice" : "300"
					},
					{
						"qty" : "100",
						"unitPrice" : "240"
					},
					{
						"qty" : "500",
						"unitPrice" : "120"
					}
				]
			}
		],
		"orderSeq" : "13",
		"imageDirectory" : "styles/image/product/headlight_cover_chrome_pilot_light_bws/",
		"productRelativeImageUrl" : [
			{
				"imageNo" : "1",
				"imageUrl" : "p1.jpg",
				"imageHint" : "圖1"
			}
		],
		"displayModelInDetail" : "false",
		"suitable_model" : [
			{
				"display_type" : "ALL",
				"model" : "BWS125/BWSX"
			}
		],
		"description" : [
			{
				"desc_index" : "1",
				"desc_content" : "・大B原廠車可直上免修改,安裝簡單"
			},
			{
				"desc_index" : "2",
				"desc_content" : "・小盾牌有不透明經典黑/透明燻黑兩款,透明燻黑內可加裝燈飾"
			}
		]
	},
	{
		"id" : 14,
		"name" : "Transparent Cooling Fan Cover",
		"name_ch" : "各車系透明燻黑風扇蓋",
		"classfied" : "Scooter",
		"sale_price" : [
			{
				"currencyTW" : "NTD$",
				"priceTW" : "500"
			}
		],
		"price" : [
			{
				"item" : "風扇蓋",
				"wholesale_price" : [
					{
						"qty" : "10",
						"unitPrice" : "400",
						"desc" : "(10搭3)"
					},
					{
						"qty" : "50",
						"unitPrice" : "250"
					},
					{
						"qty" : "100",
						"unitPrice" : "200"
					},
					{
						"qty" : "500",
						"unitPrice" : "100"
					}
				]
			}
		],
		"orderSeq" : "14",
		"imageDirectory" : "styles/image/product/transparent_cooling_fan_cover/",
		"productRelativeImageUrl" : [
			{
				"imageNo" : "1",
				"imageUrl" : "p1.jpg",
				"imageHint" : "圖1"
			},
			{
				"imageNo" : "2",
				"imageUrl" : "p2.jpg",
				"imageHint" : "圖2"
			}			
		],
		"displayModelInDetail" : "true",
		"suitable_model" : [
			{
				"display_type" : "BY_TYPE",
				"motor_system" : "K01",
				"model" : "KYMCO雷霆/雷霆S/G5/G6/超5"
			},
			{
				"display_type" : "BY_TYPE",
				"motor_system" : "M06",
				"model" : "JET POWER/JET POWER EVO/GR/Z1/GT125 EVO"
			}			
		],
		"description" : [
			{
				"desc_index" : "1",
				"desc_content" : "・彩色飾蓋為贈品有紅/藍/黃/綠/粉紅五種顏色"
			},
			{
				"desc_index" : "2",
				"desc_content" : "・改上繞/側繞/下繞排氣管均可直上免修改不卡管"
			}
		]
	},
	{
		"id" : 15,
		"name" : "Transparent Cooling Fan Cover with Chrome Bedge",
		"name_ch" : "各車系透明燻黑風扇蓋+彩鈦電鍍飾蓋",
		"classfied" : "Scooter",
		"sale_price" : [
			{
				"currencyTW" : "NTD$",
				"priceTW" : "650"
			}
		],
		"price" : [
			{
				"item" : "風扇蓋",
				"wholesale_price" : [
					{
						"qty" : "10",
						"unitPrice" : "400",
						"desc" : "(10搭3)"
					},
					{
						"qty" : "50",
						"unitPrice" : "250"
					},
					{
						"qty" : "100",
						"unitPrice" : "200"
					},
					{
						"qty" : "500",
						"unitPrice" : "100"
					}
				]
			},
			{
				"item" : "彩鈦飾蓋",
				"wholesale_price" : [
					{
						"qty" : "10",
						"unitPrice" : "120",
						"desc" : "(10搭3)"
					},
					{
						"qty" : "50",
						"unitPrice" : "90",
						"desc" : "(10搭2)"
					},
					{
						"qty" : "100",
						"unitPrice" : "60"
					},
					{
						"qty" : "500",
						"unitPrice" : "請詢價"
					}
				]
			}			
		],
		"orderSeq" : "15",
		"imageDirectory" : "styles/image/product/transparent_cooling_fan_cover_with_chrome_bedge/",
		"productRelativeImageUrl" : [
			{
				"imageNo" : "1",
				"imageUrl" : "p1.jpg",
				"imageHint" : "圖1"
			},
			{
				"imageNo" : "2",
				"imageUrl" : "p2.jpg",
				"imageHint" : "圖2"
			},
			{
				"imageNo" : "3",
				"imageUrl" : "p3.jpg",
				"imageHint" : "圖3"
			}						
		],
		"displayModelInDetail" : "true",
		"suitable_model" : [
			{
				"display_type" : "BY_TYPE",
				"motor_system" : "K01",
				"model" : "KYMCO雷霆/雷霆S/G5/G6/超5"
			},
			{
				"display_type" : "BY_TYPE",
				"motor_system" : "M06",
				"model" : "JET POWER/JET POWER EVO/GR/Z1/GT125 EVO"
			}			
		],
		"description" : [
			{
				"desc_index" : "1",
				"desc_content" : "・彩鈦電鍍飾蓋有3款可選擇"
			}
		]
	},
	{
		"id" : 16,
		"name" : "Transparent Cooling Fan Cover with Chrome Bedge, COB",
		"name_ch" : "各車系透明燻黑風扇蓋+彩鈦電鍍飾蓋+COB光圈",
		"classfied" : "Scooter",
		"sale_price" : [
			{
				"currencyTW" : "NTD$",
				"priceTW" : "1200"
			}
		],
		"price" : [
			{
				"item" : "風扇蓋",
				"wholesale_price" : [
					{
						"qty" : "10",
						"unitPrice" : "400",
						"desc" : "(10搭3)"
					},
					{
						"qty" : "50",
						"unitPrice" : "250"
					},
					{
						"qty" : "100",
						"unitPrice" : "200"
					},
					{
						"qty" : "500",
						"unitPrice" : "100"
					}
				]
			},
			{
				"item" : "彩鈦飾蓋",
				"wholesale_price" : [
					{
						"qty" : "10",
						"unitPrice" : "120",
						"desc" : "(10搭3)"
					},
					{
						"qty" : "50",
						"unitPrice" : "90",
						"desc" : "(10搭2)"
					},
					{
						"qty" : "100",
						"unitPrice" : "60"
					},
					{
						"qty" : "500",
						"unitPrice" : "請詢價"
					}
				]
			},
			{
				"item" : "COB光圈",
				"wholesale_price" : [
					{
						"qty" : "10",
						"unitPrice" : "請詢價"
					},
					{
						"qty" : "50",
						"unitPrice" : "請詢價"
					},
					{
						"qty" : "100",
						"unitPrice" : "請詢價"
					},
					{
						"qty" : "500",
						"unitPrice" : "請詢價"
					}
				]
			}					
		],
		"orderSeq" : "16",
		"imageDirectory" : "styles/image/product/transparent_cooling_fan_cover_chrome_bedge_cob/",
		"productRelativeImageUrl" : [
			{
				"imageNo" : "1",
				"imageUrl" : "p1.jpg",
				"imageHint" : "圖1"
			},
			{
				"imageNo" : "2",
				"imageUrl" : "p2.jpg",
				"imageHint" : "圖2"
			},
			{
				"imageNo" : "3",
				"imageUrl" : "p3.jpg",
				"imageHint" : "圖3"
			}						
		],
		"displayModelInDetail" : "true",
		"suitable_model" : [
			{
				"display_type" : "BY_TYPE",
				"motor_system" : "K01",
				"model" : "KYMCO雷霆/雷霆S/G5/G6/超5"
			},
			{
				"display_type" : "BY_TYPE",
				"motor_system" : "M06",
				"model" : "JET POWER/JET POWER EVO/GR/Z1/GT125 EVO"
			}			
		],
		"description" : [
			{
				"desc_index" : "1",
				"desc_content" : "・COB光圈有白/藍/紅/綠/紫五種光色;彩鈦飾蓋有E字型/指針式兩款"
			}
		]
	},
	{
		"id" : 17,
		"name" : "Rear Fender For SMAX/FORCE",
		"name_ch" : "Smax / Force 專用後擋泥板",
		"classfied" : "Scooter",
		"sale_price" : [
			{
				"currencyTW" : "NTD$",
				"priceTW" : "550"
			}
		],
		"price" : [
			{
				"item" : "擋泥板",
				"wholesale_price" : [
					{
						"qty" : "10",
						"unitPrice" : "430",
						"desc" : "(10搭3)"
					},
					{
						"qty" : "50",
						"unitPrice" : "275"
					},
					{
						"qty" : "100",
						"unitPrice" : "220"
					},
					{
						"qty" : "500",
						"unitPrice" : "130"
					}
				]
			}				
		],
		"orderSeq" : "17",
		"imageDirectory" : "styles/image/product/rear_fender_smax_force/",
		"productRelativeImageUrl" : [
			{
				"imageNo" : "1",
				"imageUrl" : "p1.jpg",
				"imageHint" : "圖1"
			},
			{
				"imageNo" : "2",
				"imageUrl" : "p2.jpg",
				"imageHint" : "圖2"
			},
			{
				"imageNo" : "3",
				"imageUrl" : "p3.jpg",
				"imageHint" : "圖3"
			},
			{
				"imageNo" : "4",
				"imageUrl" : "p4.jpg",
				"imageHint" : "圖4"
			},
			{
				"imageNo" : "5",
				"imageUrl" : "p5.jpg",
				"imageHint" : "圖5"
			},
			{
				"imageNo" : "6",
				"imageUrl" : "p6.jpg",
				"imageHint" : "圖6"
			},
			{
				"imageNo" : "7",
				"imageUrl" : "p7.jpg",
				"imageHint" : "圖7"
			}										
		],
		"displayModelInDetail" : "false",
		"suitable_model" : [
			{
				"display_type" : "ALL",
				"model" : "YAMAHA- Smax/ Force 專用"
			}	
		],
		"description" : [
			{
				"desc_index" : "1",
				"desc_content" : "・擋泥板支架為鋁合金支架,不易斷裂"
			},
			{
				"desc_index" : "2",
				"desc_content" : "・檔泥板本體有黑/白/紅/藍/綠/黃/粉紅等七種顏色"
			}			
		]
	},
	{
		"id" : 18,
		"name" : "Rear Fender For Double Cushion",
		"name_ch" : "後擋泥板-後雙避震器速可達均通用",
		"classfied" : "Scooter",
		"sale_price" : [
			{
				"currencyTW" : "NTD$",
				"priceTW" : "450"
			}
		],
		"price" : [
			{
				"item" : "擋泥板",
				"wholesale_price" : [
					{
						"qty" : "10",
						"unitPrice" : "350",
						"desc" : "(10搭3)"
					},
					{
						"qty" : "50",
						"unitPrice" : "225"
					},
					{
						"qty" : "100",
						"unitPrice" : "180"
					},
					{
						"qty" : "500",
						"unitPrice" : "110"
					}
				]
			}				
		],
		"orderSeq" : "18",
		"imageDirectory" : "styles/image/product/rear_fender_double_cushion/",
		"productRelativeImageUrl" : [
			{
				"imageNo" : "1",
				"imageUrl" : "p1.jpg",
				"imageHint" : "圖1"
			},
			{
				"imageNo" : "2",
				"imageUrl" : "p2.jpg",
				"imageHint" : "圖2"
			},
			{
				"imageNo" : "3",
				"imageUrl" : "p3.jpg",
				"imageHint" : "圖3"
			},
			{
				"imageNo" : "4",
				"imageUrl" : "p4.jpg",
				"imageHint" : "圖4"
			},
			{
				"imageNo" : "5",
				"imageUrl" : "p5.jpg",
				"imageHint" : "圖5"
			},
			{
				"imageNo" : "6",
				"imageUrl" : "p6.jpg",
				"imageHint" : "圖6"
			}								
		],
		"displayModelInDetail" : "false",
		"suitable_model" : [
			{
				"display_type" : "ALL",
				"model" : "後雙避震之速可達100cc/110cc/125cc/150cc/180cc/220cc均可使用"
			}	
		],
		"description" : [
			{
				"desc_index" : "1",
				"desc_content" : "・擋泥板支架為鋁合金支架,不易斷裂"
			},
			{
				"desc_index" : "2",
				"desc_content" : "・檔泥板本體有黑/白/紅/藍/綠/黃/粉紅等七種顏色"
			}			
		]
	},
	{
		"id" : 19,
		"name" : "Cooling Fan for SUZUKI",
		"name_ch" : "SUZUKI輕量化風扇(PP材質)",
		"classfied" : "Scooter",
		"sale_price" : [
			{
				"currencyTW" : "NTD$",
				"priceTW" : "350"
			}
		],
		"price" : [
			{
				"item" : "輕量化風扇",
				"wholesale_price" : [
					{
						"qty" : "10",
						"unitPrice" : "250",
						"desc" : "(10搭3)"
					},
					{
						"qty" : "50",
						"unitPrice" : "140"
					},
					{
						"qty" : "100",
						"unitPrice" : "請詢價"
					},
					{
						"qty" : "500",
						"unitPrice" : "請詢價"
					}
				]
			}				
		],
		"orderSeq" : "19",
		"imageDirectory" : "styles/image/product/cooling_fan_suzuki/",
		"productRelativeImageUrl" : [
			{
				"imageNo" : "1",
				"imageUrl" : "p1.jpg",
				"imageHint" : "圖1"
			},
			{
				"imageNo" : "2",
				"imageUrl" : "p2.jpg",
				"imageHint" : "圖2"
			}						
		],
		"displayModelInDetail" : "false",
		"suitable_model" : [
			{
				"display_type" : "ALL",
				"model" : "SUZUKI- address 125/V125/NEX125/GSR125/TEKKEN125/鐵拳125"
			}	
		],
		"description" : [
			{
				"desc_index" : "1",
				"desc_content" : "・PP材質,輕量化(75g),大出風量"
			},
			{
				"desc_index" : "2",
				"desc_content" : "・風扇有 橘/黃/紅/綠 四種顏色"
			}			
		]
	},
	{
		"id" : 20,
		"name" : "Chrome Decoration Bedge",
		"name_ch" : "彩鈦電鍍風扇飾蓋",
		"classfied" : "Scooter",
		"sale_price" : [
			{
				"currencyTW" : "NTD$",
				"priceTW" : "150"
			}
		],
		"price" : [
			{
				"item" : "風扇飾蓋",
				"wholesale_price" : [
					{
						"qty" : "10",
						"unitPrice" : "120",
						"desc" : "(10搭3)"
					},
					{
						"qty" : "50",
						"unitPrice" : "75"
					},
					{
						"qty" : "100",
						"unitPrice" : "60"
					},
					{
						"qty" : "500",
						"unitPrice" : "請詢價"
					}
				]
			}				
		],
		"orderSeq" : "20",
		"imageDirectory" : "styles/image/product/chrome_decoration_bedge/",
		"productRelativeImageUrl" : [
			{
				"imageNo" : "1",
				"imageUrl" : "p1.jpg",
				"imageHint" : "圖1"
			},
			{
				"imageNo" : "2",
				"imageUrl" : "p2.jpg",
				"imageHint" : "圖2"
			},
			{
				"imageNo" : "3",
				"imageUrl" : "p3.jpg",
				"imageHint" : "圖3"
			}										
		],
		"displayModelInDetail" : "false",
		"suitable_model" : [
			{
				"display_type" : "ALL",
				"model" : "YAMAHA- BWS125/BWSX/BWSR/勁戰全車系(1代~4代)/GTR/RAY"
			}	
		],
		"description" : [
			{
				"desc_index" : "1",
				"desc_content" : "・以上車系原廠風扇直上"
			},
			{
				"desc_index" : "2",
				"desc_content" : "・彩鈦電鍍飾蓋有 小旋風/指針式/E字型 三種款式"
			}			
		]
	},
	/*
	{
		"id" : 21,
		"name" : "Chrome Cooling Fan",
		"name_ch" : "彩鈦電鍍風扇(PP材質)",
		"classfied" : "Scooter",
		"sale_price" : [
			{
				"currencyTW" : "NTD$",
				"priceTW" : "299"
			}
		],
		"price" : [
			{
				"item" : "風扇",
				"wholesale_price" : [
					{
						"qty" : "10",
						"unitPrice" : "180",
						"desc" : "(10搭2)"
					},
					{
						"qty" : "50",
						"unitPrice" : "120"
					},
					{
						"qty" : "100",
						"unitPrice" : "90"
					},
					{
						"qty" : "500",
						"unitPrice" : "請詢價"
					}
				]
			}				
		],
		"orderSeq" : "21",
		"imageDirectory" : "styles/image/product/chrome_cooling_fan/",
		"productRelativeImageUrl" : [
			{
				"imageNo" : "1",
				"imageUrl" : "p1.jpg",
				"imageHint" : "圖1"
			},
			{
				"imageNo" : "2",
				"imageUrl" : "p2.jpg",
				"imageHint" : "圖2"
			}									
		],
		"displayModelInDetail" : "true",
		"suitable_model" : [
			{
				"display_type" : "BY_TYPE",
				"motor_system" : "Y001-YAMAHA車系",
				"model" : "BWS 125/BWSX/BWSR/勁戰全車系(一代~四代)/GTR aero/ RAY"
			},
			{
				"display_type" : "BY_TYPE_VENDOR",
				"motor_system" : "K03-GY6系統",
				"model" : [
					{
						"vendor" : "KYMCO",
						"model" : "雷霆/雷霆S/G3/G4/G5/G6/超5/奔騰/奔馳/豪邁/GP/VP/金牌"
					},
					{
						"vendor" : "SYM",
						"model" : "FIGHTER(一代~五代)/迪爵/GT"
					},
					{
						"vendor" : "宏佳騰",
						"model" : "OZ"
					},
					{
						"vendor" : "哈特佛",
						"model" : "大黃蜂"
					}
				]
			},
			{
				"display_type" : "BY_TYPE_VENDOR",
				"motor_system" : "K05",
				"model" : [
					{
						"vendor" : "SYM",
						"model" : "MANY100/110/125 VJR100/110/125 RX110 IRX115"
					},
					{
						"vendor" : "PGO",
						"model" : "Jbubu"
					}
				]
			},
			{
				"display_type" : "BY_TYPE",
				"motor_system" : "M07-SYM車系",
				"model" : "JET POWER (EVO)/JETS/GR/Z1/GT125 EVO/6代FIGHTER"
			}						
		],
		"description" : [
			{
				"desc_index" : "1",
				"desc_content" : "・PP材質,輕量化(約75g),大出風量"
			}	
		]
	},*/
	{
		"id" : 22,
		"orderSeq" : "22",
		"name" : "Chrome Cooling Fan (Carbon Composite Material)",
		"name_ch" : "彩鈦電鍍風扇(碳纖維複合材質)",
		"classfied" : "New",
		"sale_price" : [
			{
				"currencyTW" : "NTD$",
				"priceTW" : "520"
			}
		],
		"price" : [
			{
				"item" : "風扇蓋",
				"wholesale_price" : [
					{
						"qty" : "10",
						"unitPrice" : "320",
						"desc" : "(10搭3)"
					},
					{
						"qty" : "50",
						"unitPrice" : "200"
					},
					{
						"qty" : "100",
						"unitPrice" : "150"
					},
					{
						"qty" : "500",
						"unitPrice" : "100"
					}
				]
			}
		],
		"imageDirectory" : "styles/image/product/chrome_cooling_fan/",
		"productRelativeImageUrl" : [
			{
				"imageNo" : "1",
				"imageUrl" : "p1.jpg",
				"imageHint" : "圖1"
			},
			{
				"imageNo" : "2",
				"imageUrl" : "p2.jpg",
				"imageHint" : "圖2"
			}									
		],
		"displayModelInDetail" : "true",
		"suitable_model" : [
			{
				"display_type" : "BY_TYPE",
				"motor_system" : "Y001C-YAMAHA車系",
				"model" : "BWS 125/BWSX/BWSR/勁戰全車系(一代~四代)/GTR aero/ RAY"
			},		
			{
				"display_type" : "BY_TYPE_VENDOR",
				"motor_system" : "K03C-GY6系統",
				"model" : [
					{
						"vendor" : "KYMCO",
						"model" : "雷霆/雷霆S/G3/G4/G5/G6/超5/奔騰/奔馳/豪邁/GP/VP/金牌"
					},
					{
						"vendor" : "SYM",
						"model" : "FIGHTER(一代~五代)/迪爵/GT"
					},
					{
						"vendor" : "宏佳騰",
						"model" : "OZ"
					},
					{
						"vendor" : "哈特佛",
						"model" : "大黃蜂"
					}
				]
			},
			{
				"display_type" : "BY_TYPE_VENDOR",
				"motor_system" : "K05C- DIO迪奧系列",
				"model" : [
					{
						"vendor" : "SYM",
						"model" : "MANY100/110/125 VJR100/110/125 RX110 IRX115"
					},
					{
						"vendor" : "PGO",
						"model" : "Jbubu"
					}
				]
			},
			{
				"display_type" : "BY_TYPE",
				"motor_system" : "M07C-SYM車系",
				"model" : "JET POWER (EVO)/JETS/GR/Z1/GT125 EVO/6代FIGHTER"
			}
		],
		"description" : [
			{
				"desc_index" : "1",
				"desc_content" : "・不爆裂-使用特殊複合材質(非一般的PP材質), 增強風扇的韌性及強度,延長風扇的使用壽命!!"
			},
			{
				"desc_index" : "2",
				"desc_content" : "・高出風量-加高加大葉片結構可提高出風量,快速中和引擎所產生的熱氣,散熱效果快又好!!"
			},
			{
				"desc_index" : "3",
				"desc_content" : "・輕量化-有效提升油門的靈敏度,讓你的愛車加速更輕更快!!"
			}
		]
	}
	
	/*,
	
	{
		"id" : 22,
		"name" : "Colorful Cooling Fan",
		"name_ch" : "彩色輕量化風扇(PP材質)",
		"classfied" : "Scooter",
		"sale_price" : [
			{
				"currencyTW" : "NTD$",
				"priceTW" : "199"
			}
		],
		"price" : [
			{
				"item" : "風扇",
				"wholesale_price" : [
					{
						"qty" : "10",
						"unitPrice" : "120",
						"desc" : "(10搭3)"
					},
					{
						"qty" : "50",
						"unitPrice" : "80"
					},
					{
						"qty" : "100",
						"unitPrice" : "60"
					},
					{
						"qty" : "500",
						"unitPrice" : "請詢價"
					}
				]
			}				
		],
		"orderSeq" : "22",
		"imageDirectory" : "styles/image/product/colorful_cooling_fan/",
		"productRelativeImageUrl" : [
			{
				"imageNo" : "1",
				"imageUrl" : "p1.jpg",
				"imageHint" : "圖1"
			},
			{
				"imageNo" : "2",
				"imageUrl" : "p2.jpg",
				"imageHint" : "圖2"
			}									
		],
		"displayModelInDetail" : "true",
		"suitable_model" : [
			{
				"display_type" : "BY_TYPE",
				"motor_system" : "Y001-YAMAHA車系",
				"model" : "BWS 125/BWSX/BWSR/勁戰全車系(一代~四代)/GTR aero/ RAY"
			},
			{
				"display_type" : "BY_TYPE_VENDOR",
				"motor_system" : "K03-GY6系統",
				"model" : [
					{
						"vendor" : "KYMCO",
						"model" : "雷霆/雷霆S/G3/G4/G5/G6/超5/奔騰/奔馳/豪邁/GP/VP/金牌"
					},
					{
						"vendor" : "SYM",
						"model" : "FIGHTER(一代~五代)/迪爵/GT"
					},
					{
						"vendor" : "宏佳騰",
						"model" : "OZ"
					},
					{
						"vendor" : "哈特佛",
						"model" : "大黃蜂"
					}
				]
			},
			{
				"display_type" : "BY_TYPE_VENDOR",
				"motor_system" : "K05",
				"model" : [
					{
						"vendor" : "SYM",
						"model" : "MANY100/110/125 VJR100/110/125 RX110 IRX115"
					},
					{
						"vendor" : "PGO",
						"model" : "Jbubu"
					}
				]
			},
			{
				"display_type" : "BY_TYPE",
				"motor_system" : "M07-SYM車系",
				"model" : "JET POWER (EVO)/JETS/GR/Z1/GT125 EVO/6代FIGHTER"
			}						
		],
		"description" : [
			{
				"desc_index" : "1",
				"desc_content" : "・PP材質,輕量化(約75g),大出風量"
			},
			{
				"desc_index" : "2",
				"desc_content" : "・顏色有黃/草綠/淺藍/淺紫/深紫/深藍/螢光綠/粉紅/橘/黑/紅"
			},
			{
				"desc_index" : "3",
				"desc_content" : "・圖2為夜光風扇,只有Y001車系有夜光風扇"
			}						
		]
	}	*/																											
];

export default myProduct;


/** WEBPACK FOOTER **
 ** ./src/data/productData.js
 **/